import { OptionDto } from '@bioreferencehealth/ui-kit';
import { UserLocationsListItemDto } from '../models';

export function convertUserLocationToOptionsDto(userLocation: UserLocationsListItemDto): OptionDto {
  return {
    id: userLocation.id,
    value: userLocation.code,
    description: userLocation.name
  } as OptionDto;
}
